/**
 * I vocali nel campo della chat di MUNE (fetta 2G, 29/10/2026): il microfono, la barra della
 * registrazione al posto del campo, la riga «Trascrivo il vocale…». Il registratore e la coda
 * stanno in vocali.ts, le parole in vocaliTesto.ts. Un .tsx che non esporta costanti (Fast Refresh).
 */
import { LIMITI_VOCALI } from '@masamune/shared';
import { Icon } from '../../components/ui/Icon';
import type { UsoVocali } from './vocali';
import { PAROLE_VOCALI, tempo } from './vocaliTesto';
import './vocali.css';

/** Il microfono: accanto al campo al computer, al posto di Invia col campo vuoto al telefono. */
export function MicrofonoVocale({ vocali, disabled }: { vocali: UsoVocali; disabled?: boolean }): JSX.Element {
  return (
    <button
      type="button"
      className="btn btn-ghost btn-icon voc-microfono"
      title={PAROLE_VOCALI.registra}
      aria-label={PAROLE_VOCALI.registra}
      disabled={disabled || vocali.fase !== 'fermo'}
      onClick={vocali.registra}
    >
      <Icon name="mic" size={16} />
    </button>
  );
}

/**
 * La barra della registrazione, al posto del campo: Annulla, il pallino rosso col tempo che scorre,
 * «Ferma e trascrivi». Al telefono Ferma è un quadrato da 44 senza parole.
 */
export function BarraRegistrazione({ vocali, mobile }: { vocali: UsoVocali; mobile: boolean }): JSX.Element {
  const chiedo = vocali.fase === 'chiedo';
  const quasi = vocali.secondi >= LIMITI_VOCALI.avvisoDa;
  return (
    <div className="voc-barra" role="group" aria-label={PAROLE_VOCALI.registro}>
      <button
        type="button"
        className="btn btn-ghost btn-icon voc-annulla"
        title={PAROLE_VOCALI.annulla}
        aria-label={PAROLE_VOCALI.annulla}
        onClick={vocali.annulla}
      >
        <Icon name="x" size={16} />
      </button>
      <span className="voc-punto" aria-hidden="true" data-attivo={chiedo ? 'false' : 'true'} />
      <span className="voc-tempo">
        {chiedo ? PAROLE_VOCALI.apro : tempo(vocali.secondi)}
        {quasi && !mobile && <span className="voc-quasi"> {PAROLE_VOCALI.quasiFinito}</span>}
      </span>
      <button
        type="button"
        className="voc-ferma"
        disabled={chiedo}
        onClick={vocali.ferma}
        title={PAROLE_VOCALI.ferma}
        aria-label={PAROLE_VOCALI.ferma}
      >
        <Icon name="stop" size={12} />
        {!mobile && <span>{PAROLE_VOCALI.ferma}</span>}
      </button>
    </div>
  );
}

/** Sopra il campo: «Trascrivo il vocale…» finché il testo non arriva. */
export function RigaTrascrivo({ inCoda }: { inCoda: number }): JSX.Element | null {
  if (!inCoda) return null;
  return <div className="voc-trascrivo">{inCoda > 1 ? PAROLE_VOCALI.trascrivoAltri(inCoda) : PAROLE_VOCALI.trascrivo}</div>;
}
